
const init = (element, callback) => {
	const cancel = (event) => {
	
		if (event.preventDefault) {
    		event.preventDefault();
        	event.dataTransfer.dropEffect = 'copy';
    	}
    
        return false;
    };
        
    var drop = (event) => {
    	if (event.preventDefault) {
        	event.preventDefault();
        }
    
        const items = event.dataTransfer.files;
		callback(items);
		                        
        return false;
    };
    
    element.addEventListener('dragover', cancel);
    element.addEventListener('dragenter', cancel);
    element.addEventListener('drop', drop);        
}

const DragAndDrop = {
	init
}

export {
	DragAndDrop
}